import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { FrontEndService } from "./services/front-end.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    constructor(
        private stateService: StateService,
        public front_end_service: FrontEndService,
    ) {
    }
    
    ngOnInit() {
        // Check if user is logged in
        if (
            !localStorage.getItem('isLoggedIn') ||
            localStorage.getItem('isLoggedIn') === 'false' ||
            !localStorage.getItem('currentUser') ||
            localStorage.getItem('currentUser') === ''
        ) {
            if (!localStorage.getItem('redirect_url') || localStorage.getItem('redirect_url') === '/login') {
                localStorage.setItem('redirect_url', window.location.pathname.toString());
            }

            this.stateService.go('login');
        }
    }
}
